import React from 'react';
import type FilterGroupProps from './FilterGroupProps';
import { filterGroups } from './filterGroups';

const FilterGroup: React.FC<FilterGroupProps> = (props) => {
  const type = props.group.type;

  const Component = filterGroups[type];

  if (!Component) {
    console.warn(`No filter group found for type: "${type}"!`, props, filterGroups);
    return <></>;
  }

  return <Component {...(props as any)} />;
};

export default React.memo(FilterGroup);
